module.exports = __webpack_public_path__ + "img/Group-32708-1-1.0c8c8dca.png";